import { handleFormSubmit, useRequest } from '@polvo-labs/react-auth'
import React, { useEffect, useState } from 'react'
import { Link as RouterLink, useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { load } from 'recaptcha-v3'
import Form from '../../components/Form'
import routes from '../../config/routes'
import env from '../../config/env'
import Text from '../../components/Text'
import fields, { RegisterFormData } from './fields'
import FieldType from '../../components/Form/Fields/type'
import { termsRequiredValidation } from '../../utils/form-validations'
import Input from '../../components/Form/Fields/Input'

const RegisterForm: React.FC = () => {
  const { request } = useRequest()
  const history = useHistory()
  const [recaptcha, setRecaptcha] = useState<any>(null)

  const recaptchaToken = env.captchaKey

  useEffect(() => {
    let mounted = true
    load(recaptchaToken, { autoHideBadge: true }).then((recaptcha: any) => {
      if (mounted)
        setRecaptcha(recaptcha)
    })
    return () => {
      mounted = false
    }
  }, [])

  const [fieldsIn, setFieldsIn] = useState<FieldType<keyof RegisterFormData>[]>(fields)

  useEffect(() => {
    let mounted = true
    const formattedFields: FieldType<keyof RegisterFormData>[] = fields.map((field) => {
      if (field.name === 'accept_terms_conditions') {
        return {
          name: 'accept_terms_conditions',
          component: Input,
          data: {
            label:  <Text
              tag="p"
              style={{ textAlign: 'left', margin: 'auto' /*color: '#01579B'*/ }}
              // size="hint"
            >
              Eu aceito os &nbsp;
              <a
                href="https://iptu.app/terms"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
              >Termos de Utilizaçao</a>
            </Text>,
          },
          html: { type: 'checkbox', value: true },
          validation: termsRequiredValidation,
        }
      } else
      if (field.name === 'accept_privacy_policy') {
        return {
          name: 'accept_privacy_policy',
          component: Input,
          data: {
            label:  <Text
              tag="p"
              style={{ textAlign: 'left', margin: 'auto' /*color: '#01579B'*/ }}
              // size="hint"
            >
              Eu aceito &nbsp;
              <a
                href="https://iptu.app/privacy"
                // eslint-disable-next-line react/jsx-no-target-blank
                target="_blank"
              >Política de Privacidade</a>
            </Text>,
          },
          html: { type: 'checkbox', value: true },
          validation: termsRequiredValidation,
        }
      } else
        return field
    })
    if (mounted)
      setFieldsIn(formattedFields)
    return () => {
      mounted = false
    }
  }, [])


  const recaptchaAction = 'Register'
  return (
    <>
      <Form<RegisterFormData>
        buttonLabel="CADASTRAR"
        buttonColor="blue"
        initialValues={{
          recaptcha: '',
          name: '',
          cpf: '',
          email: '',
          phone: '',
          password: '',
          action: recaptchaAction,
          accept_terms_conditions: '',
          accept_privacy_policy: '',
          // eslint-disable-next-line @typescript-eslint/camelcase
          send_updates: '',
        }}
        fields={fieldsIn}
        onSubmit={data => {
          return recaptcha.execute(recaptchaAction).then((token: string) => {
            const dataSend = { ...data, recaptcha: token, cpf: data.cpf ? data.cpf.split('.').join('').split('-').join('').split('/').join(''): ''  }
            return handleFormSubmit({
              request: request({
                method: 'POST',
                url: `${env.apiURL}/users`,
                data: dataSend,
              }),
              onSuccess: ({ data }) => {
                toast.success('Cadastrado com successo')
                sessionStorage.setItem('id', data.data.id)
                sessionStorage.setItem('email', data.data.email)
                history.push(routes.activation_welcome.path)
              },
              onFailure: (erro: any) => {
                toast.error('Verifique os campos e tente novamente')
                if (erro.errors) {
                  return erro
                }
              },
              onValidationErrors: () => toast.error('Ocorreu um erro desconhecido'),
            })
          })
        }}
      />
    </>
  )
}

export default RegisterForm
